import React, { useCallback, useState } from 'react'
import { Button, Input, Select } from 'antd'
import { useSettingsV3 } from '../../hooks/useSettingsV3'
import { useGetFileTagsQuery } from '../../api/v2/filesV2'
import { useMyContext } from '../../context/context'

export default function Filters({ onChange, contentTypes }) {
  const [open, setOpen] = useState(true)
  const [search, setSearch] = useState()
  const [tagIds, setTagIds] = useState([])
  const [types, setTypes] = useState([])

  const { settings } = useSettingsV3()
  const { myContext } = useMyContext()

  const { data: tags } = useGetFileTagsQuery({ ...myContext })

  const onSave = useCallback(
    ({ ta, ty } = {}) => {
      onChange({ search, tagIds: ta || tagIds, types: ty || types })
      setTagIds(ta || tagIds)
      setTypes(ty || types)
    },
    [onChange, search, tagIds, types]
  )

  return (
    <div style={{ backgroundColor: '#F5F6F5', borderRadius: 16, padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ color: settings?.bgPrimaryColor, fontSize: 16, fontWeight: 700 }}>Filtrer ma recherche</div>
        <div
          style={{
            background: settings?.bgPrimaryColor,
            width: 25,
            height: 25,
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            cursor: 'pointer',
          }}
          onClick={() => setOpen(prev => !prev)}
        >
          {open ? '-' : '+'}
        </div>
      </div>
      {open && (
        <>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <div style={{ flexGrow: 2, display: 'flex' }}>
              <Input
                placeholder="Rechercher sur la plateforme"
                onChange={e => setSearch(e.target.value)}
                value={search}
                onPressEnter={() => onSave()}
              />
              <Button type="primary" onClick={() => onSave()}>
                Valider
              </Button>
            </div>
            <Select
              style={{ flexGrow: 1, width: 200 }}
              placeholder="Sélectionner un/plusieurs univers"
              options={tags?.map(t => ({ label: t.label, value: t.id }))}
              mode="multiple"
              onChange={ta => onSave({ ta })}
              value={tagIds}
              dropdownMatchSelectWidth={false}
              allowClear
            />
            <Select
              style={{ flexGrow: 1, width: 200 }}
              placeholder="Sélectionner un/plusieurs formats"
              options={contentTypes}
              mode="multiple"
              onChange={ty => onSave({ ty })}
              value={types}
              dropdownMatchSelectWidth={false}
              allowClear
            />
          </div>
        </>
      )}
    </div>
  )
}
